const BASE_URL = "https://api.hinchpm.co.uk/api/v1";
//const BASE_URL = "https://apistaging.hinchpm.com/api/v1";
//const BASE_URL = "http://localhost:3003/api/v1";
// const BASE_URL = "https://southapi.hinchpm.com/api/v1";
export const USER_API_URL = BASE_URL + "/user";
export const ADMIN_API_URL = BASE_URL + "/admin";
export const CLERK_API_URL = BASE_URL + "/clerk";
export const AGENT_API_URL = BASE_URL + "/agent";
export const PROPERTY_API_URL = BASE_URL + "/property";
export const COMPANY_API_URL = BASE_URL + "/company";
export const INSPECTION_API_URL = BASE_URL + "/inspection";
export const COMPANY_PRICELIST_URL = BASE_URL + "/company_price_list";
export const CLERK_PRICELIST_URL = BASE_URL + "/clerk_price_list";
export const CLERK_LEAVE_LIST_API_URL = BASE_URL + "/clerk/availability";
export const IMAGE_UPLOAD_API_URL = BASE_URL + "/report/images/upload";
export const LEAVE_APPLICATION_URL = BASE_URL + "/leave";
export const REPORT_ACTIONS_API_URL = BASE_URL + "/report";
export const REPORT_TITLE_IMAGE_API_URL = REPORT_ACTIONS_API_URL + "/title/update";
export const REPORT_SOC_IMAGE_API_URL = REPORT_ACTIONS_API_URL + "/soc/update";
export const REPORT_PHOTO_LINK_UPDATE_API_URL = REPORT_ACTIONS_API_URL + "/photo_link/update";
export const REPORT_TEMPLATE_API_URL = BASE_URL + "/template";
export const REPORT_TEMPLATE_MODULE_API_URL = BASE_URL + "/modules";
export const INVOICE_API_URL = BASE_URL + "/invoice";
export const REMITTANCE_API_URL = BASE_URL + "/remittance";
export const EXPENSE_API_URL = BASE_URL + "/expense";
export const PIPELINE_EXPENSE_API_URL = BASE_URL + "/pipeline_expense";
export const DASHBOARD_API_URL = BASE_URL + "/dashboard";
export const CUSTOMER_SERVICE_API_URL = BASE_URL + "/customer_service";
export const CUSTOM_REPORT_API_URL = BASE_URL + "/report/custom_report";
export const ROOM_TEMPLATE_API_URL = BASE_URL + "/room_templates/";
export const REPORT_VIEWER_API_URL = BASE_URL + "/report_viewer";
export const PROPERTY_VISIT_API_URL = BASE_URL + "/property_visit";

export const DEPOSITARY_API_URL = "https://uat.thedepositary.com/";
export const DEPOSITARY_INTEGRATION_API_URL = DEPOSITARY_API_URL + "integration/inventoryHinchPM?";





// WEBPACK FOOTER //
// ./src/constants/api_routes.js